<div *ngIf="selectedUser">
  <!-- Plans Section -->
  <div class="section">
    <h3>📦 Plans</h3>
    <ng-container
      *ngIf="selectedUser.subscribeTestSeries?.length; else noPlans"
    >
      <ng-container *ngFor="let item of selectedUser.subscribeTestSeries">
        <nz-tag *ngIf="item.isFromComboPlan" nzColor="orange">
          {{ item.planName }}
        </nz-tag>
        <nz-tag
          *ngIf="!item.isFromComboPlan && item.isUnlimited"
          nzColor="orange"
        >
          {{ item.planName }}
        </nz-tag>
      </ng-container>
    </ng-container>
    <ng-template #noPlans>
      <p class="empty-text">No plans available</p>
    </ng-template>
  </div>

  <nz-divider></nz-divider>

  <!-- Test Series Section -->
  <div class="section">
    <h3>📝 Test Series</h3>
    <ng-container
      *ngIf="selectedUser.subscribeTestSeries?.length; else noTests"
    >
      <ng-container *ngFor="let item of selectedUser.subscribeTestSeries">
        <nz-tag
          *ngIf="!item.isFromComboPlan && !item.isUnlimited"
          nzColor="green"
        >
          {{ item.testSeries[0]?.name }}
        </nz-tag>
      </ng-container>
    </ng-container>
    <ng-template #noTests>
      <p class="empty-text">No test series available</p>
    </ng-template>
  </div>
</div>
